// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-dropdown {
  position: relative;
  display: inline-block;
  margin-right: 24px;
}

/* Style for the language button */
.login-button {
  color: #163B6B;
  padding: 10px;
  background-color: #fff;
  border: 1px solid #163B6B;
  border-radius: 10px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  width: 75px;
}

/* Style for the language options */
.login-options {
  position: absolute;
  top: calc(100% + 1px);
  right: 0;
  background-color: #fff;
  border-radius: 10px;
  border: 0.2px solid #163B6B;
  border-radius: 4px;
  z-index: 1;
  width: 755px;
  padding: 0;
  display: flex;
  flex-wrap: wrap;
}
.login-options .link-group {
  padding: 0 30px;
  margin: 20px 0;
  border-left: solid 1px #163B6B;
  width: 25%;
}
.login-options .link-group:first-child {
  border-left: 0;
}
.login-options .link-group h3 {
  font-size: 16px;
  font-weight: 500;
}
.login-options .link-group ul li {
  font-size: 12px;
  margin-top: 12px;
}
.login-options .link-group ul li a {
  color: #163B6B;
  display: flex;
  align-items: center;
  position: relative;
  white-space: nowrap;
}
.login-options .link-group ul li a img {
  width: 8px;
  height: 8px;
  margin-left: 5px;
  transition: all 0.3s ease;
}
.login-options .link-group ul li a:hover img {
  transform: scale(1.2) translate(2px, -2px);
}

@media only screen and (min-width: 0px) and (max-width: 768px) {
  .login-button {
    padding: 5px 10px;
  }
  .login-options {
    width: 500px;
  }
  .login-options .link-group {
    width: 50%;
  }
  .login-options .link-group:nth-child(2n+1) {
    border-left: 0;
  }
}
@media only screen and (min-width: 0px) and (max-width: 640px) {
  .login-dropdown {
    margin-right: 12px;
    position: static;
  }
  .login-options {
    width: 100%;
  }
  .login-options .link-group {
    width: 100%;
    border-left: 0;
    margin: 10px 0;
  }
  .login-options .link-group h3 {
    font-size: 14px;
  }
  .login-options .link-group ul li {
    margin-top: 8px;
  }
}`, "",{"version":3,"sources":["webpack://./src/Components/LoginOption/LoginOption.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,qBAAA;EACA,kBAAA;AACJ;;AAEE,kCAAA;AACA;EACE,cAAA;EACA,aAAA;EACA,sBAAA;EACA,yBAAA;EACA,mBAAA;EACA,eAAA;EACA,aAAA;EACA,uBAAA;EACA,WAAA;AACJ;;AAEE,mCAAA;AACA;EACE,kBAAA;EACA,qBAAA;EACA,QAAA;EACA,sBAAA;EACA,mBAAA;EACA,2BAAA;EACA,kBAAA;EACA,UAAA;EACA,YAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;AACJ;AAAI;EACE,eAAA;EACA,cAAA;EACA,8BAAA;EACA,UAAA;AAEN;AADM;EACE,cAAA;AAGR;AADM;EACE,eAAA;EACA,gBAAA;AAGR;AAAQ;EACE,eAAA;EACA,gBAAA;AAEV;AADU;EACE,cAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;AAGZ;AAFY;EACE,UAAA;EACA,WAAA;EACA,gBAAA;EACA,yBAAA;AAId;AADc;EACE,0CAAA;AAGhB;;AAME;EACE;IACI,iBAAA;EAHN;EAKE;IACE,YAAA;EAHJ;EAII;IACE,UAAA;EAFN;EAGM;IACE,cAAA;EADR;AACF;AAKA;EACE;IACE,kBAAA;IACA,gBAAA;EAHF;EAKA;IACE,WAAA;EAHF;EAIE;IACE,WAAA;IACA,cAAA;IACA,cAAA;EAFJ;EAGI;IACE,eAAA;EADN;EAIM;IACE,eAAA;EAFR;AACF","sourcesContent":[".login-dropdown {\r\n    position: relative;\r\n    display: inline-block;    \r\n    margin-right: 24px;\r\n  }\r\n  \r\n  /* Style for the language button */\r\n  .login-button {\r\n    color: #163B6B;\r\n    padding: 10px;\r\n    background-color: #fff;\r\n    border: 1px solid #163B6B;\r\n    border-radius: 10px;\r\n    cursor: pointer;\r\n    display: flex;\r\n    justify-content: center;\r\n    width: 75px;\r\n  }\r\n    \r\n  /* Style for the language options */\r\n  .login-options {\r\n    position: absolute;\r\n    top: calc(100% + 1px);\r\n    right: 0;\r\n    background-color: #fff;\r\n    border-radius: 10px;\r\n    border: 0.2px solid #163B6B;\r\n    border-radius: 4px;\r\n    z-index: 1;\r\n    width: 755px;  \r\n    padding: 0;\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    .link-group{\r\n      padding:0 30px;\r\n      margin: 20px 0;\r\n      border-left: solid 1px #163B6B;\r\n      width: calc(100% / 4);\r\n      &:first-child{\r\n        border-left: 0;\r\n      }\r\n      h3{\r\n        font-size: 16px;\r\n        font-weight: 500;\r\n      }\r\n      ul{\r\n        li{\r\n          font-size: 12px;\r\n          margin-top: 12px;\r\n          a{\r\n            color: #163B6B;\r\n            display: flex;\r\n            align-items: center;\r\n            position: relative;\r\n            white-space: nowrap;\r\n            img{\r\n              width: 8px;\r\n              height: 8px;\r\n              margin-left: 5px;\r\n              transition: all 0.3s ease;\r\n            }\r\n            &:hover{\r\n              img {\r\n                transform: scale(1.2) translate(2px, -2px);\r\n              }\r\n            }\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }  \r\n\r\n  @media only screen and (min-width: 0px) and (max-width: 768px) {\r\n    .login-button{\r\n        padding: 5px 10px;\r\n    }\r\n    .login-options{\r\n      width: 500px;\r\n      .link-group{\r\n        width: calc(100% / 2);\r\n        &:nth-child(2n + 1){\r\n          border-left: 0;\r\n        }\r\n      }\r\n    }\r\n}\r\n@media only screen and (min-width: 0px) and (max-width: 640px) {\r\n  .login-dropdown{\r\n    margin-right: 12px;\r\n    position: static;\r\n  }\r\n  .login-options{\r\n    width: 100%;\r\n    .link-group{\r\n      width: 100%;\r\n      border-left: 0;\r\n      margin: 10px 0;\r\n      h3{\r\n        font-size: 14px;\r\n      }\r\n      ul{\r\n        li{\r\n          margin-top: 8px;\r\n        }\r\n      }\r\n    }\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
